import Vue from 'vue'

import { createResource } from './helper'

const vue = new Vue()
export const admin = createResource(vue, '/api:1/admin')
export const device = createResource(vue, '/api:1/devices{/id}')
export const devices = createResource(vue, '/api:1/devices')
export const exports = createResource(vue, '/api:1/open/export')
export const firmwareDelete = createResource(vue, '/api:1/fw/delete', {}, {}, {
  headers: {
    'content-type': 'application/x-www-form-urlencoded'
  }
})
export const firmwareList = createResource(vue, '/api:1/fw/list')
export const firmwareUpload = createResource(vue, '/api:1/fw/upload')
export const geolocation = createResource(vue, '/api:1/geolocation{/ip}')
export const image = createResource(vue, '/api:1/image')
export const infoModel = createResource(vue, '/api:1/info-model')
export const legal = createResource(vue, '/api:1/term_of_service')
export const tsdb = createResource(vue, '/api:1/tsdb/query')
export const notifications = createResource(vue, '/api:1/ruleTemplate{/id}')
export const onlineTesting = createResource(vue, '/api:1/online_testing_tool')
export const reset = createResource(vue, '/api:1/reset')
export const serviceConfig = createResource(vue, '/api:1/serviceConfig/{service}')
export const session = createResource(vue, '/api:1/session')
export const theme = createResource(vue, '/api:1/theme')
export const total = createResource(vue, '/api:1/total')
export const user = createResource(vue, '/api:1/users{/id}')
export const users = createResource(vue, '/api:1/users')

export default {
  admin,
  device,
  devices,
  exports,
  firmwareDelete,
  firmwareList,
  firmwareUpload,
  geolocation,
  image,
  infoModel,
  legal,
  tsdb,
  notifications,
  onlineTesting,
  reset,
  serviceConfig,
  session,
  theme,
  total,
  user,
  users
}



// WEBPACK FOOTER //
// ./src/api/resources.js